export default __webpack_public_path__ + "static/media/Fervent Beats.72f37792.png";